export const maEditNumberComponent = {
    bindings: {
        ngModel: '=',
        ngRequired: '=',
        decimals: '=',
        inputLabel: '@',
        unit: '@',
        help: '@',
        max: '@',
        min: '@',
    },
    require: {
        ngModelCtrl: "ngModel",
        form: '^form' // binds form to controller
    },
    template: ['$attrs', TemplateBuilder],
    controller: ['$element', AppEditCtrl],
    controllerAs: 'vm'
};
function AppEditCtrl($element) {
    const vm = this;
    this.$onInit = function () {
        vm.isRequired = function () {
            // Returns true if the input element editor has the 'required' attribute.
            // The attribute may be set by ng-required or required on the directive element.
            return !!($element.find('input').attr('required'));
        };
    };
}
function TemplateBuilder($attrs) {
    // generate input id by ng-model and random number, removing all non-word characters (allows _ though)
    // regex \W is negation shorthand for \w
    var inputId = $attrs.inputId || ('fld' + $attrs.ngModel + Math.random()).replace(/\W+/g, '');
    let inputExtra = '';
    var addonOpen = '';
    var addonClose = '';
    if ($attrs.decimals) {
        inputExtra = 'smart-float';
    }
    else {
        inputExtra = 'smart-integer';
    }
    if ($attrs.max) {
        inputExtra += ` max="{{::vm.max}}"`;
    }
    if ($attrs.min) {
        inputExtra += ` min="{{::vm.min}}"`;
    }
    if ($attrs.unit) {
        addonOpen = '<div class="input-group col-sm-4 col-md-3">';
        addonClose = `<span class="input-group-addon">{{::vm.unit}}</span></div>`;
    }
    else {
        inputExtra += ` style="max-width: 120px"`;
    }
    const required = $attrs.required !== undefined ? 'required="true"' : '';
    const html = [];
    html.push(`<div class="form-group" ng-class="{ 'has-error' : vm.form.${inputId}.$invalid }">`);
    if ($attrs.inputLabel) {
        html.push(`<label for="${inputId}" translate>{{::vm.inputLabel}}</label>`);
    }
    html.push(addonOpen);
    html.push(`<input type="text" ${required} ${inputExtra} class="form-control" id="${inputId}" name="${inputId}" ng-model="vm.ngModel"></input>`);
    html.push(addonClose);
    html.push(`<div ng-messages="vm.form.${inputId}.$error" role="alert">`);
    html.push('<p ng-message="required" class="help-block bg-danger" translate>EDIT_PAKOLLINEN_TIETO</p>');
    html.push('<p ng-message="integer" class="help-block bg-danger" translate>EDIT_VIRHEELLINEN_KOKONAISLUKU</p>');
    html.push('<p ng-message="float" class="help-block bg-danger" translate>EDIT_VIRHEELLINEN_DESIMAALILUKU</p>');
    html.push('<p ng-message="min" class="help-block bg-danger" translate translate-values="{ min: vm.min }">EDIT_MIN</p>');
    html.push('<p ng-message="max" class="help-block bg-danger" translate translate-values="{ max: vm.max }">EDIT_MAX</p>');
    html.push('</div>');
    if ($attrs.help) {
        html.push('<p class="help-block" translate>{{::vm.help}}</p>');
    }
    html.push(`</div>`); // form-group
    return html.join("\n");
} // buildTemplate
